export default __webpack_public_path__ + "static/media/cricalRight.c208be20.svg";